import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")`
        display: flex;
        flex-direction: column;
        padding: 10px;
        flex: 1;

        ${props => props.theme.breakpoints.down("md")} {
            padding: 10px 0;
        }
    `,
};
